import React, { useCallback } from 'react';

import CollapsedContent from 'components/uiLibrary/CollapsedContent';

import QuickFilterChip from 'components/Filters/Common/QuickFilterChip';
import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';

import { AGGREGATION_ON, SORT_OPTION_VALUES, TP } from 'constants/index';

import useNavigate from 'utils/hooks/useNavigate';
import { useIntersectionQuery } from 'utils/react-query';

import queries from 'containers/Productions/queries';

import { useTranslation } from 'src/i18n';

import {
  AGGREGATION_TYPES,
  FILTER_TYPE_ENTITY_TYPE_MAP,
  FILTER_TYPE_LABEL_PREFIX,
  FILTER_TYPES,
} from 'operabase-router/constants';

import classes from './FilterOptionListing.module.scss';

const FilterOptionListing = ({
  label,
  filterType,
  sort = SORT_OPTION_VALUES.PROD_COUNT_DESC,
  enableCache = false,
  trackingData = {},
}) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const navigate = useNavigate();

  const { ref, data } = useIntersectionQuery(
    queries.getQuickFilterOptions({
      ...(enableCache && { filters: { car: true } }),
      aggregationOn: AGGREGATION_ON.PRODUCTIONS,
      aggregationType: AGGREGATION_TYPES[filterType],
      limit: 300,
      sort,
      queryConfig: {
        enabled: !!filterType,
        select: response =>
          response?.map(option => ({
            ...option,
            title: t(`${TP}.FN_FILTER_PERFORMANCE_BY_SEO_LABEL`, {
              filterType: `${t(FILTER_TYPE_LABEL_PREFIX[filterType])} "${option?.name}"`,
            }),
          })),
      },
    }),
  );

  const getFilterChipLinkProps = useCallback(
    ({ option }) => {
      const applyFilterType = filterType === FILTER_TYPES.WORK_TYPE ? FILTER_TYPES.GENRE : filterType;

      return navigate.getLinkProps({
        filters: {
          [applyFilterType]: option?.id
            ? [
                {
                  entityType: FILTER_TYPE_ENTITY_TYPE_MAP[filterType],
                  entity: option,
                },
              ]
            : [],
        },
      });
    },
    [navigate, filterType],
  );

  return (
    <CollapsedContent
      maxHeightPx={150}
      labelExpandAction={t(`${TP}.FN_LOAD_X_FILTER_TYPE`, { count: data?.length || 0, filterType: label })}
      trackingData={trackingData}
    >
      <ul className={classes.root} ref={ref}>
        {data?.map(option => (
          <li key={option?.id}>
            <QuickFilterChip
              option={option}
              getLinkProps={getFilterChipLinkProps}
              trackingData={{
                ...trackingData,
                subComponent: SUB_COMPONENTS.NAVIGATE_CTA,
              }}
            />
          </li>
        ))}
      </ul>
    </CollapsedContent>
  );
};

export default FilterOptionListing;
